import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Spinner, Logo } from "@/components/kit";
import { MobileShell } from "@/components/MobileShell";

import WelcomePage from "@/pages/WelcomePage";
import LoginPage from "@/pages/auth/LoginPage";
import RegisterPage from "@/pages/auth/RegisterPage";
import ForgotPasswordPage from "@/pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/auth/ResetPasswordPage";
import VerifyEmailPage from "@/pages/auth/VerifyEmailPage";
import OnboardingPage from "@/pages/onboarding/OnboardingPage";
import AppShell from "@/pages/app/AppShell";
import DiscoverPage from "@/pages/app/DiscoverPage";
import RequestsPage from "@/pages/app/RequestsPage";
import ChatsPage from "@/pages/app/ChatsPage";
import ProfilePage from "@/pages/app/ProfilePage";
import SettingsPage from "@/pages/app/SettingsPage";

const Splash = () => (
  <MobileShell hideBrandPanel>
    <div className="min-h-[100dvh] flex flex-col items-center justify-center gap-6">
      <Logo variant="stacked" className="h-24 animate-rise" />
      <Spinner />
    </div>
  </MobileShell>
);

function Protected({ children }) {
  const { user, booting } = useAuth();
  if (booting || user === null) return <Splash />;
  if (!user) return <Navigate to="/welcome" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, booting } = useAuth();
  if (booting || user === null) return <Splash />;
  if (user) return <Navigate to="/app/discover" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" toastOptions={{ style: { background: "#253B35", color: "#F8F6F1", border: "none", fontFamily: "'Plus Jakarta Sans', sans-serif" } }} />
      <Routes>
        <Route path="/welcome" element={<PublicOnly><WelcomePage /></PublicOnly>} />
        <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
        <Route path="/register" element={<PublicOnly><RegisterPage /></PublicOnly>} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />

        <Route path="/onboarding" element={<Protected><OnboardingPage /></Protected>} />

        <Route path="/app" element={<Protected><AppShell /></Protected>}>
          <Route index element={<Navigate to="/app/discover" replace />} />
          <Route path="discover" element={<DiscoverPage />} />
          <Route path="requests" element={<RequestsPage />} />
          <Route path="chats" element={<ChatsPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/welcome" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
